import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MortgageCalculator.tsx");
